"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var colour_1 = require("./icons/colour");
var material_1 = require("@mui/material");
var Fab = __importStar(require("./A_Fab"));
var Component = function (p) {
    return (Preact.h(material_1.Zoom, { in: p.show, appear: false, unmountOnExit: true },
        Preact.h(Fab.Component, { variant: "circular", color: "secondary", sx: p.sx, onClick: p.onClick, size: p.size },
            Preact.h(colour_1.ColourIcon, null))));
};
exports.Component = Component;
